export default "__VITE_ASSET__2a84db08__"